const includeHeaders = (query, queryHeaders) => {
  const headers = {
    context: {
      headers: queryHeaders,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  };

  return Object.assign(query, headers);
};

export default includeHeaders;
